<template>
  <div>
    <slot v-if="hasAccess" />
    <q-dialog v-else-if="sessionIsReady" :model-value="true" persistent data-cy="site-access-dialog">
      <q-card :class="{ shake: shakeDialog }" style="min-width: 350px" data-cy="site-access-card">
        <q-card-section class="flex items-center">
          <q-icon name="fas fa-lock-alt" size="sm" color="grey" left />
          <div class="text-h6" data-cy="site-access-title">Site Password Required</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-input
            v-model="passwordInput"
            type="password"
            placeholder="Enter Password"
            outlined
            data-cy="site-access-password-input"
            @keyup.enter="validatePassword"
          >
            <template #prepend> </template>
          </q-input>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            label="Go"
            color="primary"
            :loading="isValidating"
            data-cy="site-access-submit-button"
            @click="validatePassword"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup>
import { isTrueProduction, hasNonProdAccessFlag, setNonProdAccessFlag } from '@/utils/env.util'

const $q = useQuasar()
const sessionStore = useSessionStore()
const { sessionIsReady } = storeToRefs(sessionStore)

const isProduction = $q.platform.is.nativeMobile || isTrueProduction()
const passwordInput = ref('')
const isValidating = ref(false)
const shakeDialog = ref(false)
const hasAccess = ref(isProduction || hasNonProdAccessFlag())

function doShake() {
  shakeDialog.value = true
  setTimeout(() => {
    shakeDialog.value = false
  }, 500)
}

async function validatePassword() {
  isValidating.value = true

  try {
    // Call Netlify function to verify password server-side
    const response = await fetch('/api/verify-access', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password: passwordInput.value }),
    })

    // 200 = valid password, 401 = invalid password
    if (response.ok) {
      // Store a simple flag (not the password) in localStorage
      setNonProdAccessFlag(true)
      hasAccess.value = true
    } else {
      throw new Error('Invalid password')
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error validating password:', error)
    // Trigger shake animation on error
    doShake()
  } finally {
    passwordInput.value = ''
    isValidating.value = false
  }
}
</script>

<style lang="scss" scoped></style>
